import React from 'react';
import { ShieldCheckIcon, FileDownIcon } from 'lucide-react';
import { BuyButton } from './BuyButton';
import { images } from '../data/siteConfig';
export function HeroSection() {
  return <section id="top" className="bg-white" data-id="element-59" data-mp="23vl2kq18q8un">
      <div className="mx-auto grid max-w-6xl gap-8 px-5 pb-16 pt-10 lg:grid-cols-[1.05fr_1fr] lg:gap-x-14 lg:gap-y-8 lg:pb-24 lg:pt-16" data-id="element-60" data-mp="23wmib7t7bjip">
        <div className="lg:col-start-1 lg:row-start-1 lg:self-end" data-id="element-61" data-mp="2wjpdpr2kze4q">
          <p className="font-display text-xs font-bold uppercase tracking-[0.18em] text-aqua sm:text-sm" data-id="element-62" data-mp="2wkii4le2hrjp">
            The practical guide for home pool owners
          </p>
          <h1 className="mt-4 font-display text-4xl font-extrabold leading-[1.08] text-navy sm:text-5xl lg:text-[3.4rem]" data-id="element-63" data-mp="2mt4ec1f325kr">
            Know What Your Pool Needs. Know What to Do Next.
          </h1>
          <p className="mt-5 max-w-xl text-lg leading-relaxed text-ink" data-id="element-64" data-mp="3fht81fdt78mh">
            Learn how to test your water, build a maintenance routine, and troubleshoot common pool
            problems—with a visual guide designed for beginners.
          </p>
        </div>

        <div className="lg:col-start-2 lg:row-span-2 lg:row-start-1 lg:self-center" data-id="element-65" data-mp="2be6r01dpzao6">
          <img src={images.bundleMockup} alt="The main pool care guide surrounded by the five bonus PDFs" className="w-full rounded-3xl shadow-[0_24px_60px_rgba(16,48,71,0.18)]" data-id="element-66" data-mp="2p5bn4thvpktr" />
        </div>

        <div className="lg:col-start-1 lg:row-start-2 lg:self-start" data-id="element-67" data-mp="2z2gd74eui0fu">
          <div className="max-w-xl rounded-2xl border border-line bg-mist p-5 sm:p-6" data-id="element-68" data-mp="2u4ogzy763s5u">
            <p className="font-display text-lg font-bold text-navy" data-id="element-69" data-mp="3847iw99dy79p">
              Complete Digital Guide + 5 FREE Bonus PDFs
            </p>
            <p className="mt-1 text-ink" data-id="element-70" data-mp="336earaoiv36s">
              <span className="font-display text-2xl font-extrabold text-navy" data-id="element-71" data-mp="333a0bvkgrb7o">$33 USD</span>
              <span className="mx-2 text-ink/50" data-id="element-72" data-mp="1ds98i3zcb5c8">·</span>
              One-Time Payment
            </p>
            <div className="mt-5" data-id="element-73" data-mp="18tg20vih0elk">
              <BuyButton label="GET MY POOL CARE PACK — $33" href="#offer" fullWidth data-id="element-74" data-mp="38u4j0xyqp68r" />
            </div>
            <p className="mt-4 flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-sm text-ink" data-id="element-75" data-mp="3drmk626imh67">
              <span className="inline-flex items-center gap-1.5" data-id="element-76" data-mp="3iqfuxmuf3u2o">
                <FileDownIcon className="h-4 w-4 text-aqua" aria-hidden="true" data-id="element-77" data-mp="3msuhoi17jdz8" />
                Digital PDF Downloads
              </span>
              <span className="inline-flex items-center gap-1.5" data-id="element-78" data-mp="3rre56mvg8xtp">
                <ShieldCheckIcon className="h-4 w-4 text-aqua" aria-hidden="true" data-id="element-79" data-mp="lcnhvgzb5z3" />
                10-Day Money-Back Guarantee
              </span>
            </p>
          </div>
        </div>
      </div>
    </section>;
}